import { makeApi } from '@zodios/core';
import { z } from 'zod';
import { errors, tenantSchema, apiKeySchema } from './schemas/common.schema';

const tenantApi = makeApi([
  {
    method: 'post',
    path: '/v1/tenant',
    alias: 'createTenant',
    description: 'Create a new tenant (admin only)',
    parameters: [
      {
        name: 'body',
        type: 'Body',
        schema: z.object({
          name: z.string().min(1),
          description: z.string().optional(),
        }),
      },
    ],
    response: tenantSchema,
    errors,
  },
  {
    method: 'get',
    path: '/v1/tenant',
    alias: 'listTenants',
    description: 'List all tenants (admin only)',
    response: z.array(tenantSchema),
    errors,
  },
  {
    method: 'delete',
    path: '/v1/tenant/:tenantId',
    alias: 'deactivateTenant',
    description: 'Deactivate (soft delete) a tenant (admin only)',
    parameters: [
      { name: 'tenantId', type: 'Path', schema: z.string() },
    ],
    response: z.object({ message: z.string() }),
    status: 204,
    errors,
  },
  {
    method: 'post',
    path: '/v1/tenant/:tenantId/apikey',
    alias: 'createApiKey',
    description: 'Create a new API key for a tenant',
    parameters: [
      {
        name: 'tenantId',
        type: 'Path',
        schema: z.string(),
      },
      {
        name: 'body',
        type: 'Body',
        schema: z.object({
          name: z.string().min(1),
          description: z.string().optional(),
          expiresAt: z.string().datetime().optional(),
        }),
      },
    ],
    response: z.object({
      ...apiKeySchema.shape,
      apiKey: z.string(),
    }),
    errors,
  },
  {
    method: 'get',
    path: '/v1/tenant/:tenantId/apikey',
    alias: 'listApiKeys',
    description: 'List API keys for a tenant',
    parameters: [
      {
        name: 'tenantId',
        type: 'Path',
        schema: z.string(),
      },
    ],
    response: z.array(apiKeySchema),
    errors,
  },

  {
    method: 'patch',
    path: '/v1/tenant/:tenantId/apikey/:keyId',
    alias: 'updateApiKey',
    description: 'Update API key status (activate/deactivate)',
    parameters: [
      {
        name: 'tenantId',
        type: 'Path',
        schema: z.string(),
      },
      {
        name: 'keyId',
        type: 'Path',
        schema: z.string(),
      },
      {
        name: 'body',
        type: 'Body',
        schema: z.object({
          isActive: z.boolean(),
        }),
      },
    ],
    response: z.object({ message: z.string() }),
    status: 204,
    errors,
  },
  {
    method: 'delete',
    path: '/v1/tenant/:tenantId/apikey/:keyId',
    alias: 'deleteApiKey',
    description: 'Permanently delete an API key',
    parameters: [
      {
        name: 'tenantId',
        type: 'Path',
        schema: z.string(),
      },
      {
        name: 'keyId',
        type: 'Path',
        schema: z.string(),
      },
    ],
    response: z.object({ message: z.string() }),
    status: 204,
    errors,
  },
]);

export default tenantApi;